module.exports = __webpack_public_path__ + "static/media/builtinv2-Монтаж-СКС.5fd88b9e.jpg";